@if (bannerNode | async ; as item) {
  <div id="laptop-row" class="row"
    [ngClass]="{'laptop':currentSite=='seqirusb2b-uk'}">
    <!-- <div class="col-xs-12 col-md-6 hide-laptop-desktop">
    <img class="laptop-image-mobile" [src]="getImage(item.media)">
  </div> -->
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 laptopParent">
    <div class="laptop-paragraph-content">
      <h2>{{item.headline}}</h2>
      <p>{{item.h2content}}</p>
      <ul [ngClass]="{'list':currentSite=='seqirusb2b-uk'}" [innerHTML]="item.paragraphcontent"></ul>
      <!--for coding and billing-->
      @if (item?.paragraphcontent) {
        <p class="coding-billing-boldContent d-none" [innerHTML]="item.paragraphcontent">
        </p>
      }
      @if (item?.content) {
        <div class="button--download-outline-red d-none">
          <a [href]="getpdf(item.mediaPdf)" target="_blank">{{item.content}}</a>
        </div>
      }
    </div>
  </div>
  @if (item?.media) {
    <div class="col-xs-12 col-md-6 hide-laptop-mobile dashlapimage">
      <img class="laptop-image" alt="laptop with the flu360 account dashboard on screen" [src]="getImage(item.media)">
    </div>
  }
  <!--for coding and billing page-->
  @if (item?.mediaPicture) {
    <div class="col-xs-12 col-md-6 col-lg-6 col-sm-12 hide-laptop-mobile dashlapimage codingnbillingimage d-none"
      >
      <img class="laptop-image" alt="CodingBillingPortfolioGuide"
        [src]="getcodingnbillingimage(item.mediaPicture)">
      </div>
    }
  </div>
}